import calendardots from "./calendardots.svg";

export default function CalendarIcon() {
  return (
    <img src={calendardots} />
  );
}